module.exports = __webpack_public_path__ + "static/media/EventCreationExample.0c8b8afe.png";